module.exports = __webpack_public_path__ + "static/media/after_text.5a51f070.pdf";


//////////////////
// WEBPACK FOOTER
// ./src/assets/pdfs/hymns/after_text.pdf
// module id = 779
// module chunks = 2